import mapboxgl from 'mapbox-gl';

export function getBounds(coordinates, type) {
  let coordinates_flat = coordinates.flat(1);

  if (coordinates_flat[0].length > 2) {
    coordinates_flat = coordinates_flat.flat(1);
  }

  if (coordinates_flat[0].length > 2) {
    coordinates_flat = coordinates_flat.flat(1);
  }

  // Create a 'LngLatBounds' with both corners at the first coordinate.
  if (coordinates_flat.length == 1) {
    coordinates_flat = coordinates_flat[0];
  }

  let bounds = new mapboxgl.LngLatBounds(
    coordinates_flat[0],
    coordinates_flat[0]
  );

  // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
  for (const coord of coordinates_flat) {
    bounds.extend(coord);
  }
  return bounds;
}
